import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "./config";

export interface GeneralAuditEvent {
  id: string;
  action: string;
  entityType?: string;
  entityId?: string;
  actor?: { uid?: string; email?: string; name?: string; role?: string };
  reason?: string;
  changes?: Record<string, unknown>;
  related?: Record<string, unknown>;
  createdAt?: any;
}

/** Bounded admin query: one listener is unnecessary for an audit archive. */
export async function getRecentAuditEvents(maxRows = 250): Promise<GeneralAuditEvent[]> {
  const snap = await getDocs(query(collection(db, "auditEvents"), orderBy("createdAt", "desc"), limit(Math.min(500, Math.max(1, maxRows)))));
  return snap.docs.map((row) => ({ id: row.id, ...row.data() } as GeneralAuditEvent));
}
